import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../../i18n/I18nContext';
import './OutilsLanding.css';

function OutilsLanding() {
  const { t } = useI18n();
  return (
    <div className="outils-landing">
      <div className="outils-header">
        <h1>{t.tools.title}</h1>
        <p>{t.tools.subtitle}</p>
      </div>

      <div className="outils-grid">
        <Link to="/outils/calculateur" className="outil-card glass-card">
          <div className="outil-icon">
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
              <rect x="4" y="20" width="40" height="24" rx="3" stroke="currentColor" strokeWidth="2"/>
              <path d="M24 4L4 20h40L24 4z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
              <rect x="18" y="30" width="12" height="14" rx="1" stroke="currentColor" strokeWidth="2"/>
              <line x1="12" y1="36" x2="12" y2="40" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              <line x1="36" y1="36" x2="36" y2="40" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </div>
          <h3>{t.tools.calcTitle}</h3>
          <p>{t.tools.calcDesc}</p>
          <span className="outil-cta">{t.tools.calculate}</span>
        </Link>

        <Link to="/outils/estimateur" className="outil-card glass-card">
          <div className="outil-icon">
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
              <path d="M8 40V16l16-12 16 12v24H8z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
              <circle cx="24" cy="26" r="8" stroke="currentColor" strokeWidth="2"/>
              <path d="M24 22v8M20 26h8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </div>
          <h3>{t.tools.estimTitle}</h3>
          <p>{t.tools.estimDesc}</p>
          <span className="outil-cta">{t.tools.estimate}</span>
        </Link>

        <Link to="/outils/comparateur" className="outil-card glass-card">
          <div className="outil-icon">
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
              <rect x="4" y="28" width="10" height="16" rx="2" stroke="currentColor" strokeWidth="2"/>
              <rect x="19" y="18" width="10" height="26" rx="2" stroke="currentColor" strokeWidth="2"/>
              <rect x="34" y="8" width="10" height="36" rx="2" stroke="currentColor" strokeWidth="2"/>
              <line x1="2" y1="44" x2="46" y2="44" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </div>
          <h3>{t.tools.comparTitle}</h3>
          <p>{t.tools.comparDesc}</p>
          <span className="outil-cta">{t.tools.compare}</span>
        </Link>
      </div>
    </div>
  );
}

export default OutilsLanding;
